import React from "react";
import AppRouter from "./navigation/AppRouter";

function App() {
  return <AppRouter />;
}

export default App;
